import { useTranslation } from 'next-i18next'
import styled, { css, FlattenSimpleInterpolation } from 'styled-components'

import { colors } from '@/styles'
import { Label } from '@/components/text'
import { Tooltip } from '@/components/tooltip'
import VerifiedBadge from '@/components/verified-badge'

interface PillProps {
  darkText?: boolean
  color?: string
  customStyle?: FlattenSimpleInterpolation | undefined
  children?: React.ReactNode
  id?: string
}

const Wrapper = styled.div<PillProps>`
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  min-height: 24px;
  min-width: 35px;
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 8px;
  z-index: 10;
  color: ${colors.grey16};
  ${({ color }) => `background: ${color}`};
  ${({ customStyle }) => customStyle};
`

const Pill: React.FC<PillProps> = ({ color = '#fff', ...rest }) => (
  <Wrapper color={color} {...rest} />
)

export const PillWrapper = styled.div`
  position: absolute;
  top: 12px;
  left: 8px;
  display: flex;
  flex-direction: row-reverse;
  > div:not(:first-of-type) {
    margin-right: 8px;
  }
`

const Container = styled.div`
  position: absolute;
  top: 6px;
  left: 24px;
`

const WidePill = styled(Pill)<PillProps>`
  min-width: 80px;
`

const tooltip = css`
  width: 20px;
  height: 20px;
  position: absolute;
  top: 2px;
  left: 2px;
`

export const VerifiedPill = ({
  disableTooltip
}: {
  disableTooltip?: boolean
}) => {
  const { t } = useTranslation()
  return (
    <WidePill id="verified-badge">
      <Tooltip
        position="right"
        customStyle={tooltip}
        disabled={disableTooltip}
        top="0"
        left="0"
        text={t(
          'b.listing.view.address_verified.tooltip',
          'This listing is address verified.'
        )}
      >
        <VerifiedBadge
          verified
          position="absolute"
          type="listing"
          height={20}
          width={20}
          right={0}
          bottom={0}
        />
      </Tooltip>
      <Container>
        <Label fontSize="12px" type="large">
          {t('common.verified', 'Verified')}
        </Label>
      </Container>
    </WidePill>
  )
}
